import { default as MuiTableHead, TableHeadProps } from '@mui/material/TableHead'
import * as React from 'react'

export const TableHead = React.forwardRef<HTMLTableSectionElement, TableHeadProps>(({ sx, ...props }, ref) => {
  return <MuiTableHead {...props} ref={ref} sx={{ '>  .MuiTableRow-root': { backgroundColor: '#eee' }, ...sx }} />
})

export default TableHead
